import "moment/locale/it"
import { Col, Row } from "react-bootstrap"
import { statNumberToString } from "../../../../apis/transform/stats"
import style from "./style.module.scss"
import Image from "next/image"
import minutesImg from "@assets/icons/players/Minuti.svg"
import goalImg from "@assets/icons/players/Gol.svg"
import assistsImg from "@assets/icons/players/Assist.svg"
import gamesPlayedImg from "@assets/icons/players/Partite.svg"

export function PlayerMinutes({
  minutes,
  contrasts,
  goals,
  assists,
  gamesPlayed,
}: {
  minutes: number
  contrasts: number
  goals: number
  assists: number
  gamesPlayed: number
}) {
  return (
    <Row className={style.firstRow}>
      <div className={style.circle} />
      <Col className={`${style.element} ${style.borderBottom}`} xs={6} sm={6} md={6} lg={3} xl={3}>
        <dl>
          <dt className={style.icon}>
            <Image src={gamesPlayedImg} width={50} height={50} alt="games played" />
          </dt>
          <div className={style.data}>
            <dt className={style.label}>Partite Giocate</dt>
            <dd className={style.value}>{statNumberToString(gamesPlayed)}</dd>
          </div>
        </dl>
      </Col>
      <Col
        className={`${style.element} ${style.noBorderMobile} ${style.borderBottom}`}
        xs={6}
        sm={6}
        md={6}
        lg={3}
        xl={3}
      >
        <dl>
          <dt className={style.icon}>
            <Image src={minutesImg} width={50} height={50} alt="matches" />
          </dt>
          <div className={style.data}>
            <dt className={style.label}>Minuti giocati</dt>
            <dd className={style.value}>{statNumberToString(minutes)}</dd>
          </div>
        </dl>
      </Col>
      <Col className={style.element} xs={6} sm={6} md={6} lg={3} xl={3}>
        <dl>
          <dt className={style.icon}>
            <Image src={goalImg} width={50} height={50} alt="fouls" />
          </dt>
          <div className={style.data}>
            <dt className={style.label}>Gol</dt>
            <dd className={style.value}>{statNumberToString(goals)}</dd>
          </div>
        </dl>
      </Col>
      <Col className={style.element} xs={6} sm={6} md={6} lg={3} xl={3}>
        <dl>
          <dt className={style.icon}>
            <Image src={assistsImg} width={50} height={50} alt="fouls" />
          </dt>
          <div className={style.data}>
            <dt className={style.label}>Assist</dt>
            <dd className={style.value}>{statNumberToString(assists)}</dd>
          </div>
        </dl>
      </Col>
    </Row>
  )
}
